export default __webpack_public_path__ + "static/media/Boligmappa-Plus-Logo.4b243e5c.png";